import { AxiosResponse } from "axios";
import { toast } from "react-hot-toast";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import { enableUserDailyMessageLimitSuccess } from "../slices/features/users";
import { RequestTypes } from "../types";
import { enableDidDailyMessageLimitFailure } from "../slices/features/did";

const usersService = new AppService();

function* enableUserDailyMessageLimit(action: any) {
  const { payload } = action;
  const { id, data } = payload;

  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      usersService.enableUserDailyMessageLimit,
      baseUrl,
      id,
      data
    );

    toast.success(
      `User daily message limit ${data.enabled ? "enabled" : "disabled"} successfully!`
    );

    yield put(enableUserDailyMessageLimitSuccess({ ...response }));
    action.payload?.cbSuccess && action.payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const {
      data: {
        errors: { message },
      },
    } = error;

    toast.error(Array.isArray(message) ? message[0] : message);

    yield put(enableDidDailyMessageLimitFailure({ statusCode, statusText }));
  }
}

export function* watchEnableUserDailyMessageLimit() {
  yield takeLatest(RequestTypes.ENABLE_USER_DAILY_MESSAGE_LIMIT, enableUserDailyMessageLimit);
}
